import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { VehicleValuationSelectVehicleView } from "./vehicle-valuation-select-vehicle.view";

export function VehicleValuationInitializeRoutes() {
  return (
    <Switch>
      <Route path="/" component={() => <Redirect to="~/fab/list" replace />} />
      <Route path="/select-vehicle" component={VehicleValuationSelectVehicleView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
